import { Turbo } from "@hotwired/turbo-rails"
import { Modal } from "bootstrap"

// Every data-turbo-confirm goes through the Bootstrap modal #turbo-confirm instead of window.confirm.
Turbo.config.forms.confirm = (message) => {
  const element = document.getElementById("turbo-confirm")
  if (!element) return Promise.resolve(window.confirm(message))

  element.querySelector("[data-confirm-message]").textContent = message
  const modal = Modal.getOrCreateInstance(element)
  const accept = element.querySelector("[data-confirm-accept]")

  return new Promise((resolve) => {
    let confirmed = false
    // Bootstrap's hide() is a no-op while the modal is still fading in, so "Да" is disabled until
    // the modal is fully shown; otherwise a lost accept click could leave `confirmed` set by mistake.
    accept.disabled = true
    const onShown = () => { accept.disabled = false }
    // Once hiding starts (after "Отмена", Esc or a backdrop click) the fade-out must not accept a late click.
    const onHide = () => { accept.disabled = true }
    const onAccept = () => { confirmed = true; modal.hide() }
    element.addEventListener("shown.bs.modal", onShown, { once: true })
    element.addEventListener("hide.bs.modal", onHide, { once: true })
    accept.addEventListener("click", onAccept)
    // Resolve after the modal is hidden so the backdrop is gone before Turbo navigates.
    element.addEventListener("hidden.bs.modal", () => {
      element.removeEventListener("shown.bs.modal", onShown)
      element.removeEventListener("hide.bs.modal", onHide)
      accept.removeEventListener("click", onAccept)
      accept.disabled = false
      resolve(confirmed)
    }, { once: true })
    modal.show()
  })
}
